import React, { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import './App.css';

import Menu from './Menu';
import Make from './Make';
import Srch from './Srch';
import Info from './Info';

function App() {

  const [menu, setMenu] = useState(true);
  const [make, setMake] = useState(false);
  const [srch, setSrch] = useState(false);
  const [info, setInfo] = useState(false);
  const [lang, setLang] = useState(`ja`);

  useEffect(() => {

  })

  const [t, i18n] = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLang(lng);
  };

  const pg = (goto) => {
    switch (goto) {
      case 'menu':
        setMenu(true);
        setMake(false);
        setSrch(false);
        setInfo(false);
        break;
      case 'make':
        setMenu(false);
        setMake(true);
        break;
      case 'srch':
        setMenu(false);
        setSrch(true);
        break;
      case 'info':
        setMenu(false);
        setInfo(true);
        break;
    }
  }

  return (
    <div>
      <div className="Aiyaa">POWERED BY <b>AIYAA</b>
      <button onClick={() => changeLanguage('ja')}>JA</button>
      <button onClick={() => changeLanguage('en')}>EN</button>
      <button onClick={() => changeLanguage('cn')}>CN</button>
      </div>
      {menu && <Menu pg={pg} lng={lang}/>}
      {make && <Make pg={pg} lng={lang}/>}
      {srch && <Srch pg={pg} lng={lang}/>}
      {info && <Info pg={pg} lng={lang}/>}
    </div>
  );


}

export default App;
